import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataManipulationService } from '../../../services/data-manipulation.service';

@Component({
  selector: 'app-workspace-upgraded-modal',
  templateUrl: './workspace-upgraded-modal.component.html',
  styleUrls: ['./workspace-upgraded-modal.component.scss']
})
export class WorkspaceUpgradedModalComponent {

  constructor(private dialogRef: MatDialogRef<any>, private data: DataManipulationService, private router: Router) { }

  close(result?: any) {
    this.dialogRef.close(result);
  }

  goToDashboardPlan() {
    if(this.data.lastRouteBeforeBilling === 'menu') {
      this.close();
      this.router.navigate(['/']);
    } else {
      this.close();
      this.router.navigate([this.data.lastRouteBeforeBilling]);
    }
  }
}
